<template>
  <div v-if="dataLoaded.user" style="height: 100%; width: 100%; justify-content: center" class="flexwrap">

    <settings-card v-if="step === 'plans'">
      <template v-slot:title>
        <template v-if="profile.datas.is_premium">Mon abonnement m'offre ...</template>
        <template v-else>En m'abonnant j'accède à ...</template>
      </template>
      <template v-slot:description>
        Voici les avantages des différentes offres.
      </template>
      <template v-slot:content>
        <div style="display:flex; flex-direction:column; justify-content: space-between; align-content: center; align-items: center; max-width: 100%; max-height: 100%; overflow: auto;">
          <free-vs-premium :isPremium="profile.datas.is_premium"></free-vs-premium>

          <div v-if="profile.datas.is_premium && !justSub">
            <div class="flexwrap centercenter" style="flex-direction: column"
                 v-if="profile.datas.status!='deleted'">
              Prochain paiment prévu le {{new Date(profile.datas.next_bill_date).getDate()}} /
              {{new Date(profile.datas.next_bill_date).getMonth()+1}} /
              {{new Date(profile.datas.next_bill_date).getFullYear()}}.
              <standard-button :color-class="'olive'" @click="unsubscribe" >
                Me désabonner
              </standard-button>
            </div>
            <div v-else> Ton abonnement prendra fin le {{new Date(profile.datas.next_bill_date).getDate()}} /
              {{new Date(profile.datas.next_bill_date).getMonth()+1}} /
              {{new Date(profile.datas.next_bill_date).getFullYear()}}.</div>
          </div>

          <div v-else-if="justSub">
            <div class="flexwrap centercenter" style="flex-direction: column">
              <h2 style="align-content: center"><center>Merci de faire confiance à notre méthode ! Si tu t'y tiens, tu progresseras.</center></h2>
            </div>
          </div>

          <div class="flexwrap" style="justify-content: center; height: fit-content" v-else>
            <premium-plans :paddle="paddle"
                           @checkout="startCheckout"
            >
            </premium-plans>
          </div>
        </div>

      </template>
    </settings-card>

    <inline-checkout v-else-if="step === 'checkout'" style="width: 100%"
                     :plan="plan"
                     :paddle="paddle"
                     :profile="profile"
                     :checkout-loaded="checkoutIsLoaded"
                     :currentStep="checkoutStep"
                     @sub="subbed()"
    >
    </inline-checkout>


  </div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import SettingsCard from "@/components/settingsCard";

export default {
  name: "premium",
  components: {
    SettingsCard,
    InlineCheckout: () => import(/* webpackPrefetch: true */ '@/components/inlineCheckout.vue'),
    StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue'),
    premiumPlans: () => import(/* webpackPrefetch: true */ '@/components/premiumPlans.vue'),
    freeVsPremium: () => import(/* webpackPrefetch: true */ '@/components/freeVsPremium.vue')
  },

  created() {
    // On charge la librairie paddle
    this.$loadScript("https://cdn.paddle.com/paddle/paddle.js")
        .then(() => {
          Paddle.Setup({
            vendor: 122555,
            eventCallback: (data) => {
              // The data.event will specify the event type
              if (data.event === "Checkout.Loaded") {
                console.log('checkout loaded')
                this.checkoutIsLoaded = true;
              }
              if (data.event === "Checkout.Location.Submit") {
                this.checkoutStep = 2;
              }
              if (data.event === "Checkout.PaymentMethodSelected") {
                this.checkoutStep = 3;
              }
              if (data.event === "Checkout.PaymentMethodSelected") {
                this.checkoutStep = 3;
              }
              if (data.event === "Checkout.PaymentComplete") {
                this.checkoutStep = 4;
              }
            }
          });
          this.paddleLoaded = true;
          this.paddle = Paddle;
        })
  },

  beforeDestroy() {
    this.paddle = null;
  },

  computed: {
    ...mapGetters('global', [
        'isMobile', 'profile',
        'dataLoaded'
    ]),

    checkoutIsLoaded: {
      get: function() {
        return this.checkoutLoaded;
      },
      set: function(value) {
        this.checkoutLoaded = value
      }
    }
  },

  methods: {
    ...mapActions('global', [
      'change_userData',
    ]),

    subbed: function() {
      this.justSub = true;
      this.step = 'plans';
      this.change_userData({
        name: 'is_premium',
        value: true
      })
    },

    unsubscribe: function() {
      Paddle.Checkout.open({
        override: this.profile.datas.cancel_url,
        successCallback: () => {
          this.change_userData({
            name: 'is_premium',
            value: false
          })
        }
      });
    },

    startCheckout: function(plan) {
      this.step = 'checkout';
      this.plan = plan
    }
  },

  data() {
    return {
      step: 'plans',
      plan: {
        duration: 12,
        price: 59.99,
      },
      paddleLoaded: false,
      checkoutLoaded: false,
      paddle: {},
      justSub: false,
      checkoutStep: 1
    }
  }
}
</script>

<style scoped>
  #premiumBody{
    padding-top: 3vw;
    max-width: 100%;
   /* width: calc(100% - 10%);*/
    max-height: 100%;
    height: calc(100% - 5vw);
    /*padding: 1vw;*/
    display: grid;
    grid-gap: 1vw;
    grid-template-rows: auto 1fr;
    justify-content: center;
    justify-items: center;
    overflow: hidden;
  }

  .description {


  }

  @media screen and (max-device-width: 767px) {
    #premiumBody{
      min-height: calc(100% - 8vw);
      height: calc(100% - 6vw);
      /*width: calc(100% - 6vw);*/
      /*padding: 3vw;*/
      width: 90%;
      grid-gap: 3vw;
      overflow: auto;
    }

  }
</style>
